import Vue from "vue";
import { generateUUID, deepClone, sleep, showError } from "@/utils";
import { baseURL_WSS } from "@/utils/request";

const toolItem = {
  chatList: [],
  status: 0, // 0完成 1 响应中 2 响应失败或错误 3响应中断 4响应等待
  type: 1,
  uuId: generateUUID(),
  chatTask: null,
  taskStatus: 0, // CLOSED: 3 CLOSING: 2 CONNECTING: 0 OPEN: 1
  toastData: {
    visible: false,
    tips: ""
  },
  // 是否主动断开链接
  isProactiveDisconnect: false,
  // 心跳包计数
  pingCount: 0,
  pingTimer: null,
  // 接收定时器 超过65秒没有响应 结束本条会话 后端也做了超时60秒
  receiveTimer: null,
  receiveTimerFn() {
    this.pingCount = 0;
    clearTimeout(this.receiveTimer);
    this.receiveTimer = setTimeout(() => {
      clearTimeout(this.receiveTimer);
      const chat = this.chatList.slice(-1)[0];
      this.status = 2;
      chat.status = 2;
      chat.tokenTotal = 0;
      chat.text = "当前排队用户过多，请稍后重试。";
    }, 65000);
  }
};

const state = {
  editInfo: {},
  toolMap: {}
};
const stoppingText = "终止中...";
const onMessage = (e, tool) => {
  let data = e.data;
  try {
    data = JSON.parse(data);
  } catch {
    //
  }

  if (typeof data === "string") {
    if (data === "pong") {
      console.log(data);
      tool.pingCount--;
    }
    return;
  }
  const { msg = "", tag, uuid } = data;
  // 本组消息
  const isGroup = uuid === tool.uuId;
  if (!isGroup) return;
  // 本条消息开始传输
  const isStart = tag === "start";
  // 已终止回答
  const isStop = tag === "stop";
  // 本条消息结束传输
  const isEnd = tag === "end";
  // 本条消息附加字段
  const isUsage = tag === "usage";
  // 错误字段
  const isError = tag === "textError";
  // 系统标签
  const isSystemTag = tag === "systemTag";
  // 文档段落
  const isDoc = tag == "doc";
  const chat = tool.chatList.slice(-1)[0];
  if (!chat) return;
  if (isSystemTag) {
    // 系统标签
    const { imageList, replyContext } = msg;
    chat.text = replyContext;
    chat.imageList = imageList;
    return;
  }
  // 开始
  if (isStart) {
    chat.status = 1;
    tool.status = 1;
    chat.text = "";
    return;
  }
  // 已停止回答
  if (isStop) {
    if (!chat.text) {
      chat.text = msg || "已终止回答";
      chat.status = 3;
      tool.status = 3;
      clearTimeout(tool.receiveTimer);
    }
    return;
  }
  // 错误
  if (isError) {
    chat.text += msg;
    chat.status = 2;
    chat.tokenTotal = 0;
    tool.status = 2;
    clearTimeout(tool.receiveTimer);
    return;
  }
  if (isUsage) {
    chat.tokenTotal = msg.c;
    clearTimeout(tool.receiveTimer);
    return;
  }
  // 引用文档
  if (isDoc) {
    chat.doc = msg;
    chat.docCount = msg.length || 0;
  }
  // 非传输中
  if (chat?.status !== 1 && chat?.status !== 5) return;
  // 结束了更新状态
  if (isEnd) {
    chat.status = 0;
    tool.status = 0;
    // 接收完成后清除定时器
    clearTimeout(tool.receiveTimer);
  } else {
    // 传输中字符串累加
    chat.text += msg;
    //每次接收重置定时器
    tool.receiveTimerFn();
  }
};

const mutations = {
  SET_TOAST_DATA(state, params) {
    if (state.toolMap[params.toolId]) {
      state.toolMap[params.toolId].toastData = params;
    }
  },
  // 开启新会话
  RE_START(state, params) {
    const tool = state.toolMap[params.toolId];
    const chatList = tool.chatList;
    const chat = chatList.slice(-1)[0];
    // 已经是新对话
    if (!chat || chat.type == -1) {
      this.commit("chat/SET_TOAST_DATA", {
        tips: "已经是新对话了，我们继续吧~",
        visible: true,
        toolId: params.toolId
      });
      return;
    }
    // 正在对话中
    if (tool.status === 1 || tool.status === 4) {
      this.commit("chat/SET_TOAST_DATA", {
        tips: "正在回答，请稍后再试",
        visible: true,
        toolId: params.toolId
      });
      return;
    }
    if (tool.status === 5) {
      this.commit("chat/SET_TOAST_DATA", {
        tips: "终止中，请稍后再试",
        visible: true,
        toolId: params.toolId
      });
      return;
    }
    // 开启新对话+
    tool.uuId = generateUUID();
    chatList.push({
      type: -1,
      id: generateUUID(),
      uuId: tool.uuId
    });
  },
  SEND_MESSAGE(state, params) {
    if (!state.toolMap[params.toolId]) {
      Vue.set(state.toolMap, params.toolId, deepClone(toolItem));
    }
    const tool = state.toolMap[params.toolId];
    // 正在对话中
    if (tool.status === 1 || tool.status === 4) {
      this.commit("chat/SET_TOAST_DATA", {
        tips: "正在回答，请稍后再试",
        visible: true,
        toolId: params.toolId
      });
      return;
    }
    if (tool.status === 5) {
      this.commit("chat/SET_TOAST_DATA", {
        tips: "终止中，请稍后再试",
        visible: true,
        toolId: params.toolId
      });
      return;
    }
    const chatList = tool.chatList;
    const msgId = generateUUID();
    // 添加当前发送的消息到消息列表
    chatList.push({
      text: params.question,
      parsedText: params.parsedQuestion,
      status: 0,
      type: 0,
      id: generateUUID(),
      groupId: msgId,
      uuId: tool.uuId,
      context: "",
      contextLoading: false
    });
    // 添加一个表示ai正在处理的数据
    chatList.push({
      text: "正在思考",
      status: 4,
      type: 1,
      id: msgId,
      groupId: msgId,
      tokenTotal: null,
      imageList: null,
      uuId: tool.uuId,
      docCount: 0,
      doc: [] // 文档段落
    });
    tool.status = 4;
    // 响应时间计算
    tool.receiveTimerFn();
    const data = {
      code: tool.type,
      msg: {
        msg: params.parsedQuestion || params.question,
        uuid: tool.uuId,
        cmd: params.cmd || 0, // 0 后台调试消息 1 前端发送消息 2 终止消息 3重试消息  4删除消息
        assistantId: params.toolId,
        msgId: msgId
      }
    };
    tool.chatTask?.send(JSON.stringify(data));
    params?.success?.();
  },
  // 停止响应
  STOP(state, { toolId }) {
    // 当前类型的聊天记录
    const tool = state.toolMap[toolId];
    const chatList = tool.chatList;
    const chat = chatList.slice(-1)[0];
    if (!chat || (chat.status !== 4 && chat.status !== 1)) return;
    if (chat.status === 4) {
      chat.text = stoppingText;
    }
    chat.status = 5;
    tool.status = 5;
    const data = {
      code: tool.type,
      msg: {
        uuid: tool.uuId,
        cmd: 2, // 0 后台调试消息 1 前端发送消息 2 终止消息 3重试消息  4删除消息
        msgId: chat.id,
        assistantId: toolId
      }
    };
    tool.chatTask?.send(JSON.stringify(data));
    tool.receiveTimerFn();
  },
  // 重新生成回答
  RE_ANSWER(state, { question, parsedQuestion, retryMsgId, toolId }) {
    const tool = state.toolMap[toolId];
    if (tool.status === 1 || tool.status === 4) {
      this.commit("chat/SET_TOAST_DATA", {
        tips: "正在回答，请稍后再试",
        visible: true,
        toolId
      });
      return;
    }
    if (tool.status === 5) {
      this.commit("chat/SET_TOAST_DATA", {
        tips: "终止中，请稍后再试",
        visible: true,
        toolId
      });
      return;
    }
    const chatList = tool.chatList;
    const msgId = generateUUID();
    // 添加当前发送的消息到消息列表
    chatList.push({
      text: question,
      parsedText: parsedQuestion,
      status: 0,
      type: 0,
      id: generateUUID(),
      groupId: msgId,
      uuId: tool.uuId,
      context: "",
      contextLoading: false
    });
    // 添加一个表示ai正在处理的数据
    chatList.push({
      text: "正在思考",
      status: 4,
      type: 1,
      id: msgId,
      groupId: msgId,
      tokenTotal: null,
      imageList: null,
      uuId: tool.uuId,
      docCount: 0,
      doc: []
    });
    tool.status = 4;
    // 响应时间计算
    tool.receiveTimerFn();
    const data = {
      code: tool.type,
      msg: {
        msg: parsedQuestion || question,
        uuid: tool.uuId,
        cmd: 3,
        assistantId: toolId,
        msgId,
        retryMsgId
      }
    };
    tool.chatTask?.send(JSON.stringify(data));
  },
  // 设置问答的上下文
  SET_CONTEXT(state, { toolId, index, context, loading }) {
    const tool = state.toolMap[toolId];
    const chatList = tool.chatList;
    const chat = chatList[index];
    chat.context = context;
    chat.contextLoading = loading;
  },
  // 清空聊天记录
  CLEAR(state, { toolId }) {
    const tool = state.toolMap[toolId];
    if (tool) {
      tool.status = 0;
      tool.chatList = [];
      tool.uuId = generateUUID();
      clearTimeout(tool.receiveTimer);
    }
  },
  // 断开链接
  DISCONNECT(state, { toolId }) {
    const tool = state.toolMap[toolId];
    if (tool) {
      tool.isProactiveDisconnect = true;
      // 用于标记 控制台好看日志
      tool.chatTask?.send("DISCONNECT");
      tool.chatTask?.close(1000);
      tool.pingCount = 0;
      clearInterval(tool.pingTimer);
    }
  },
  // 删除记录
  SEND_DELETE(state, { question, parsedQuestion, msgId, uuId, toolId }) {
    const tool = state.toolMap[toolId];
    const data = {
      code: tool.type,
      msg: {
        msg: parsedQuestion || question,
        uuid: uuId || tool.uuId,
        cmd: 4, // 0 后台调试消息 1 前端发送消息 2 终止消息 3重试消息  4删除消息
        assistantId: toolId,
        msgId: msgId
      }
    };

    tool.chatTask?.send(JSON.stringify(data));
  },
  // 删除记录
  DELETE_RECORD(state, { type, index, toolId }) {
    const tool = state.toolMap[toolId];
    if (tool.status === 1 || tool.status === 4) {
      this.commit("chat/SET_TOAST_DATA", {
        tips: "正在回答，请稍后再试",
        visible: true,
        toolId
      });
      return;
    }
    if (tool.status === 5) {
      this.commit("chat/SET_TOAST_DATA", {
        tips: "终止中，请稍后再试",
        visible: true,
        toolId
      });
      return;
    }
    const chatList = tool.chatList;
    let question = "";
    let parsedQuestion = "";
    let msgId = "";
    if (type == 0) {
      // 问题
      question = chatList[index].text;
      parsedQuestion = chatList[index].parsedText;
      msgId = chatList[index + 1].id;
      chatList.splice(index, 2);
    } else {
      // 答案
      question = chatList[index - 1].text;
      parsedQuestion = chatList[index - 1].parsedText;
      msgId = chatList[index].id;
      chatList.splice(index - 1, 2);
    }
    this.commit("chat/SEND_DELETE", {
      question,
      parsedQuestion,
      msgId,
      toolId
    });
  },
  // 存储编辑内容
  SET_EDIT_INFO(state, params) {
    state.editInfo = Object.assign({}, params);
  },
  // 清除编辑内容
  CLEAR_EDIT_INFO(state) {
    state.editInfo = Object.assign({});
  },
  // 更新会话
  UPDATE_SOCKET(state, { toolId, type }) {
    // 如果原来有记录，取原来的uuId,没有就用新的uuId
    const tool = state.toolMap[toolId];
    const chatList = tool.chatList;
    const chat = chatList && chatList.slice(-1)[0];
    const uuId = chat?.uuId || generateUUID();
    tool.type = type;
    tool.uuId = uuId;
  },
  CONNECT_SOCKET(
    state,
    {
      applicationIdentity,
      token,
      toolId,
      type,
      isResetList = false,
      uuId = generateUUID()
    }
  ) {
    // 没有当前类型对应的数组，就创建一个； 或者需要重置之前的数据的情况下，也重新创建一个
    if (!state.toolMap[toolId] || isResetList) {
      Vue.set(state.toolMap, toolId, deepClone(toolItem));
    }
    const tool = state.toolMap[toolId];
    tool.isProactiveDisconnect = false;
    // 错误时 重新连接次数
    let reconnectCount = 0;
    tool.type = type;
    tool.uuId = uuId;
    tool.status = 0;
    // 如果已经连接上则不在链接
    if (tool.chatTask && tool.taskStatus === 1) return;
    // 链接次数
    let connectCount = 0;
    // 是否关闭旧链接
    let isCloseOldTask = false;
    // 链接socket
    const connect = async () => {
      // 关闭旧链接
      if (isCloseOldTask) {
        tool.chatTask?.close(1000);
        await sleep();
      }
      connectCount++;
      console.log(
        `工具ID：${toolId} 链接地址：${baseURL_WSS}/ws?thirdApplicationId=${applicationIdentity}&token=${token}`
      );
      tool.chatTask = new WebSocket(
        `${baseURL_WSS}/ws?thirdApplicationId=${applicationIdentity}&token=${token}`
      );
      // 链接成功
      tool.chatTask.onopen = async () => {
        tool.taskStatus = 1;
        connectCount = 0;
        tool.pingCount = 0;
        console.log(`${toolId} 链接成功！ ${new Date().toLocaleString?.()}`);
        // 用于标记 控制台好看日志
        tool.chatTask?.send("CONNECT");
        // 防止如果有上一个需要的task没有close关掉这个就open了 然后下面关于isCloseOldTask的判断就有问题
        await sleep();
        isCloseOldTask = false;
      };
      // 链接错误
      tool.chatTask.onerror = e => {
        const text = `[连接失败] ${e.errMsg || ""}`;
        const chat = tool.chatList.slice(-1)[0];
        // 如果最新一条没得文本，则证明最新一条崩了，给它附上错误提示
        if (chat?.status === 4 || chat?.status === 5) {
          chat.text = text;
          chat.status = 2;
          chat.tokenTotal = 0;
        }
        tool.taskStatus = 3;
        tool.status = 2;
        // 重新连接
        if (
          reconnectCount < 5 &&
          !isCloseOldTask &&
          !tool.isProactiveDisconnect
        ) {
          connect();
        } else if (reconnectCount >= 5) {
          showError("对话网络错误，请刷新页面重试");
        }
        console.log(`${toolId} 链接错误！${new Date().toLocaleString?.()}`);
      };

      tool.chatTask.onclose = () => {
        tool.taskStatus = 3;
        // 重新链接
        if (
          connectCount < 5 &&
          !isCloseOldTask &&
          !tool.isProactiveDisconnect
        ) {
          connect();
        }
        console.log(`${toolId} 链接关闭！${new Date().toLocaleString?.()}`);
      };
      // 接收消息
      tool.chatTask.onmessage = e => {
        onMessage(e, tool);
      };
    };
    connect();
    // 5秒发送一次心跳消息
    clearInterval(tool.pingTimer);
    tool.pingTimer = setInterval(() => {
      if (tool?.status !== 1 && tool?.status !== 5) {
        tool.chatTask?.send(`ping`);
        tool.pingCount++;
      }
      // 2次ping没有回复pong 重新链接
      if (tool.pingCount > 1 && connectCount < 5) {
        // 重新链接
        isCloseOldTask = true;
        connect();
        const chat = tool.chatList.slice(-1)[0];
        if (chat?.status === 4 || chat?.text === stoppingText) {
          tool.status = 2;
          chat.status = 2;
          chat.tokenTotal = 0;
          chat.text = "当前排队用户过多，请稍后重试。";
        }
        console.log(tool.pingCount, connectCount);
      }
    }, 5000);
  }
};

export default {
  namespaced: true,
  state,
  mutations
};
